import React from "react";

import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";

import AlbumSection from "../components/GalleryPage/AlbumSection.jsx";
import AlbumDetail from "../components/GalleryPage/Gallery/AlbumDetail.jsx";


export default function GalleryPage({ type = "albumSection" }) {

    const MainSection = {
        albumSection: <AlbumSection />,
        albumDetail: <AlbumDetail />,
    }[type] || <AlbumSection />;

    return <>
            <Header />
            { MainSection }
            <Footer />
        </>

}
